/**
 * @module Helper
 */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Interceptor for adding credentials to HTTP requests in the Angular application.
 *
 * This service implements the HttpInterceptor interface to modify outgoing HTTP requests
 * by enabling the `withCredentials` option. This allows cookies and authentication headers
 * to be sent with cross-origin requests.
 *
 * @helper
 * @@Injectable
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
	/**
	 * Creates an instance of the CredentialsInterceptor.
	 *
	 * @constructor
	 */
	constructor() {}

	/**
	 * Intercepts an outgoing HTTP request and modifies it to include credentials.
	 *
	 * @param {HttpRequest<any>} request - The HTTP request to intercept.
	 * @param {HttpHandler} next - The next handler in the chain to process the request.
	 * @returns {Observable<HttpEvent<any>>} An observable of the HTTP event stream.
	 */
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		request = request.clone({ withCredentials: true });
		return next.handle(request);
	}
}
